import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { NavLink, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Logo from "../../../assets/logo.png";

import CloseIco from "../../../assets/icons/close.svg";
import "./index.scss";

import { authActions } from "../../../redux/actions/onboarding";
import { FaChevronDown } from "react-icons/fa";

// type OwnProps = HeaderProps & ReturnType<typeof mapStateToProps>;
export const SideBarWrap = ({ pageProps }: any) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [isBlogOpen, setIsBlogOpen] = useState(false);

  // Auto-open dropdown if one of the links is active
  useEffect(() => {
    if (
      location.pathname.startsWith("/app/products") ||
      location.pathname.startsWith("/app/categories")
    ) {
      setIsOpen(true);
    }

    // Auto-open Blog dropdown
    if (location.pathname.startsWith("/app/blog")) {
      setIsBlogOpen(true);
    }
  }, [location]);
  let loggedAccountInfo: any = localStorage.getItem("mami-Super-XAuth") || "{}",
    userStores: any[];

  if (loggedAccountInfo) {
    loggedAccountInfo = JSON.parse(loggedAccountInfo);
    userStores = loggedAccountInfo.myStores;
  }
  const BizName = () => {
    return (
      <div className="bizname-wrap">
        <Link className="logo-head" to={`/app`}>
          <img src={Logo} alt="" />
        </Link>
        <div className="admin_txt">Super Admin</div>
      </div>
    );
  };

  const MenuItems = () => {
    return (
      <div className="all-menu-items">
        <div className="menu-item">
          <NavLink
            end
            className={({ isActive }) => (isActive ? "active-nav" : "")}
            to="/app"
          >
            <div className="menu-icon dash-ico">
              <span></span>
            </div>
            <div className="menu-txt">Dashboard</div>
          </NavLink>
        </div>
        <div className={`menu-select-item ${isBlogOpen ? "open" : ""}`}>
          <button
            className="menu-toggle"
            onClick={() => setIsBlogOpen((prev) => !prev)}
          >
            <div className="menu-icon blog-ico">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  color: location.pathname.startsWith("/app/blog")
                    ? "#00A759"
                    : "#A6A6A6",
                  transition: "color 0.2s ease",
                }}
              >
                <path
                  d="M14.6654 6.66732V10.0007C14.6654 13.334 13.332 14.6673 9.9987 14.6673H5.9987C2.66536 14.6673 1.33203 13.334 1.33203 10.0007V6.00065C1.33203 2.66732 2.66536 1.33398 5.9987 1.33398H9.33203"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.6654 6.66732H11.9987C9.9987 6.66732 9.33203 6.00065 9.33203 4.00065V1.33398L14.6654 6.66732Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.66797 8.66602H8.66797"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.66797 11.334H7.33464"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="menu-txt">Blog</div>
            <span className={`arrow ${isBlogOpen ? "rotated" : ""}`}>
              <FaChevronDown size={20} color="#9B9B9B" />
            </span>
          </button>

          {isBlogOpen && (
            <div className="submenu">
              <NavLink
                className={({ isActive }) => (isActive ? "active-nav" : "")}
                to="/app/blog"
                end
              >
                All Posts
              </NavLink>

              <NavLink
                className={({ isActive }) => (isActive ? "active-nav" : "")}
                to="/app/blog/categories"
              >
                Categories
              </NavLink>
            </div>
          )}
        </div>
        <div className="menu-item">
          <NavLink
            className={({ isActive }) => (isActive ? "active-nav" : "")}
            to="/app/stores"
          >
            <div className="menu-icon stores-ico">
              <span></span>
            </div>
            <div className="menu-txt">Stores</div>
          </NavLink>
        </div>
        {/* <div className="menu-item">
          <NavLink
            className={({ isActive }) => (isActive ? "active-nav" : "")}
            to="/app/vendors"
          >
            <div className="menu-icon vendors-ico">
              <span></span>
            </div>
            <div className="menu-txt">Vendors</div>
          </NavLink>
        </div> */}
        <div className="menu-item">
          <NavLink
            className={({ isActive }) => (isActive ? "active-nav" : "")}
            to="/app/orders"
          >
            <div className="menu-icon order-ico">
              <span></span>
            </div>
            <div className="menu-txt">Orders</div>
          </NavLink>
        </div>
        <div className="menu-item">
          <NavLink
            className={({ isActive }) => (isActive ? "active-nav" : "")}
            to="/app/customers"
          >
            <div className="menu-icon customer-ico">
              <span></span>
            </div>
            <div className="menu-txt">Customers</div>
          </NavLink>
        </div>
        <div className={`menu-select-item ${isOpen ? "open" : ""}`}>
          <button
            className="menu-toggle"
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <div className="menu-icon prod-ico">
              <span></span>
            </div>
            <div className="menu-txt">Products</div>
            <span className={`arrow ${isOpen ? "rotated" : ""}`}>
              <FaChevronDown size={20} color="#9B9B9B" />{" "}
            </span>
          </button>

          {isOpen && (
            <div className="submenu">
              <NavLink
                className={({ isActive }) => (isActive ? "active-nav" : "")}
                to="/app/products"
              >
                All products
              </NavLink>

              <NavLink
                className={({ isActive }) => (isActive ? "active-nav" : "")}
                to="/app/categories"
              >
                Categories
              </NavLink>
            </div>
          )}
        </div>
        <div className="menu-item">
          <NavLink
            className={({ isActive }) => (isActive ? "active-nav" : "")}
            to="/app/media"
          >
            <div className="menu-icon media-ico">
              <span></span>
            </div>
            <div className="menu-txt">Media</div>
          </NavLink>
        </div>
        <div className="menu-item">
          <NavLink
            className={({ isActive }) => (isActive ? "active-nav" : "")}
            to="/app/settings"
          >
            <div className="menu-icon settings-ico">
              <span></span>
            </div>
            <div className="menu-txt">Settings</div>
          </NavLink>
        </div>

        <div className="menu-item   ">
          <div onClick={() => pageProps.logoutAction()} className="logout_wrap">
            <div className="menu-icon logout-ico">
              <span></span>
            </div>
            <div className="menu-txt logout">Logout</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={
        !pageProps?.isMobile ? "sidebar-wrap" : "sidebar-wrap withmobile"
      }
    >
      {pageProps?.isMobile && (
        <div
          className="sidebar-close"
          onClick={() => pageProps?.setShowVisible(false)}
        >
          <img src={CloseIco} alt="" />
        </div>
      )}

      <BizName />
      <MenuItems />
    </div>
  );
};

const SideBar = (pageProps: any, isMobile?: any) => {
  // const { productId } = useParams();
  // useEffect(() => {

  //         getProductDetail({
  //             pageProps,
  //             payload: "CLEAR"
  //         })

  // }, [])
  return (
    <>
      {pageProps?.isMobile && <div className="underlay_mobile"></div>}
      <SideBarWrap pageProps={pageProps} isMobile={isMobile} />
    </>
  );
};
const mapDispatchToProps = {
  logoutAction: authActions.Logout,
};

const mapStateToProps = (state: any) => {
  return {
    // loginRequest: state.onboardingOutboundReducers.loginReducer,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
